export default __webpack_public_path__ + "static/17-2bd721237b40bdde64a36e622231e75f.jpg";